export default {
  state: {
    mostrarBread: false,
    bread: []
  },
  mutations: {
    setMostrarBread(state, _mostrar) {
      state.mostrarBread = _mostrar;
    },
    setBread(state, _bread) {
      state.bread = _bread;
    }
  },
  getters: {
    getMostrarBread: state => state.mostrarBread,
    getBread: state => state.bread
  }
};
